import {
  SET_REPORT_EXPORTS,
  UPDATE_REPORT_EXPORT,
  SET_PANEL_IS_OPEN,
} from '../actions/actionTypes';
import { ReportExport } from '../config/types/reports';
import { ReportAction, ReportStateType } from '../context';

export default (
  state: ReportStateType,
  action: ReportAction,
): ReportStateType => {
  switch (action.type) {
    case SET_REPORT_EXPORTS: {
      return {
        ...state,
        reportExports: action.payload,
      };
    }
    case UPDATE_REPORT_EXPORT: {
      const updatedExport = action.payload as ReportExport;
      let updatedPanelIsOpen = state.panelIsOpen;
      const newReportExports = state.reportExports ? [...state.reportExports] : [];
      const existingIndex = newReportExports.findIndex(r => r.id === updatedExport.id);
      if (existingIndex !== -1) {
        newReportExports[existingIndex] = updatedExport;
      } else {
        newReportExports.push(updatedExport);
        // Always open the panel when a new item is added
        updatedPanelIsOpen = true;
      }
      return {
        ...state,
        reportExports: newReportExports,
        panelIsOpen: updatedPanelIsOpen,
      };
    }
    case SET_PANEL_IS_OPEN:
      return {
        ...state,
        panelIsOpen: action.payload,
      };
    default:
      return state;
  }
};
